import React from "react";
import { Spinner } from "react-bootstrap";
interface loadingProp {
  className?: string;
}
export const Loading: React.FC<loadingProp> = ({ className }) => {
   return (
    <div className={className}>
      <Spinner />
    </div>
  );
};
